<div class="container-fluid">
  <div class="row d-flex">
    <div class="col-sm-12 mb-3 mt-3">
      <ul class="d-flex">
        <li class="header-search-box d-flex col-sm-7">
          <!--  <form class="col-sm-12 position-relative" (submit)="searchString(searchBar.value, $event)">
            <label for="header-search-input"></label
            ><input
              class="pl-5"
              id="header-search-input"
              #searchBar
              [value]="searchTerms"
              name="searchBar"
              placeholder="{{ 'TYPE_TO_SEARCH' | translate }}"
              [formControl]="searchControl"
              autocomplete="off"
            />
            <div
              class="header-search-button position-absolute"
              id="header-search"
              (click)="searchString(searchBar.value, $event)"
            >
              <i id="search-icon" class="fa fa-search"></i>
            </div>
            <div class="close-search-button position-absolute" (click)="clearSearchTerm()">
              <i class="fa fa-close"></i>
            </div>
          </form>-->

          <!--<app-suggest-list
            [isOpenSuggestList]="isOpenSuggestList$ | async"
            (querySuggest$)="searchString($event.query, $event.event)"
            [suggestData]="suggestResponse$ | async"
            [searchQuery]="searchTerms$ | async"
            [isSuggestLoading]="isSuggestLoading$ | async"
            [isSuggestLoaded]="isSuggestLoaded$ | async"
          >
          </app-suggest-list>-->
        </li>
        <!--        <li class="col-sm-2 d-none d-md-block header-page-histories">-->
        <!--          <i class="fa fa-clock-o" aria-hidden="true"></i>-->
        <!--        </li>-->
        <!--        <li class="col-sm-1 d-none d-md-block ml-auto header-page-notification">-->
        <!--          <i class="fa fa-bell-o" aria-hidden="true"></i>-->
        <!--        </li>-->
        <!--        <li class="col-sm-1 d-none d-md-block ml-auto header-page-bookmarks">-->
        <!--          <i class="fa fa-bookmark-o" aria-hidden="true"></i>-->
        <!--        </li>-->
        <li ngbDropdown placement="bottom-right" class="ms-auto d-none d-md-block header-page-lang col-sm-2 ps-0">
          <app-etx-icons name="language"></app-etx-icons>
          <div [ngSwitch]="lang">
            <span *ngSwitchCase="'fr'" class="dropdown-item" ngbDropdownToggle> FR </span>
            <span *ngSwitchCase="'en'" class="dropdown-item" ngbDropdownToggle> EN </span>
            <span *ngSwitchCase="'en-fr'" class="dropdown-item" ngbDropdownToggle> EN+FR </span>
            <div ngbDropdownMenu>
              <span
                class="dropdown-item fr"
                (click)="changeContentLang('fr')"
                *ngIf="lang !== 'fr'"
                ngbDropdownItem
                [routerLink]="[currentUrl, 'fr']"
                >FR</span
              >
              <span
                class="dropdown-item en"
                (click)="changeContentLang('en')"
                *ngIf="lang !== 'en'"
                ngbDropdownItem
                [routerLink]="[currentUrl, 'en']"
                >EN</span
              >
              <span
                class="dropdown-item en-fr"
                (click)="changeContentLang('en')"
                *ngIf="lang !== 'en-fr'"
                ngbDropdownItem
                [routerLink]="[currentUrl, 'en-fr']"
                >EN-FR</span
              >
            </div>
          </div>
        </li>

        <li ngbDropdown placement="bottom-right" class="col-sm-1 header-page-user">
          <div ngbDropdownToggle class="user-btn" [ngClass]="{ logged: isLogged }">
            <span class="user-icon">
              <i id="user-icon" class="fa fa-user-o"></i>
            </span>
            <!-- <span *ngIf="isLogged" class="user-name" id="user-name">
              {{ (user$ | async)?.username }}
            </span>-->
          </div>
          <div ngbDropdownMenu class="user-account">
            <ul *ngIf="isLogged">
              <li>
                <a class="dropdown-item" (click)="goToPreferencesPage()">
                  <i class="fa fa-cog me-2"></i><span>{{ 'PREFERENCES' | translate }}</span></a
                >
              </li>
              <li class="d-md-none d-sm-block">
                <a [routerLink]="['./', 'bookmarks', 'all', lang]" class="dropdown-item"
                  ><i class="fa fa-bookmark-o me-2"></i><span>{{ 'ALL_MY_SAVED_ITEMS' | translate }}</span></a
                >
              </li>
              <li class="d-md-none d-sm-block">
                <a [routerLink]="" class="dropdown-item"
                  ><i class="fa fa-bell-o me-2"></i><span>{{ 'NOTIFICATIONS' | translate }}</span></a
                >
              </li>
              <li class="d-md-none d-sm-block">
                <a [routerLink]="" class="dropdown-item"
                  ><i class="fa fa-clock-o me-2"></i><span>{{ 'NOTIFICATIONS' | translate }}</span></a
                >
              </li>
              <li>
                <a (click)="logout()" class="dropdown-item"
                  ><i class="fa fa-sign-out me-2"></i><span>{{ 'LOG_OUT' | translate }}</span></a
                >
              </li>
            </ul>
            <ul *ngIf="!isLogged">
              <li>
                <a [routerLink]="['/login']" class="dropdown-item"
                  ><i class="fa fa-sign-in me-2"></i><span>{{ 'LOGIN' | translate }}</span></a
                >
              </li>
              <li>
                <a [routerLink]="" class="dropdown-item"
                  ><i class="fa fa-cog me-2"></i><span>{{ 'REGISTER' | translate }}</span></a
                >
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
